import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import { getImg } from 'src/services/AssetApi';
import ZoomImage from 'src/components/zoom-image';

export const DetailView = ({ item, apiPayBill }) => {
  const imageSrc = useMemo(() => getImg(item.asset?.name), [item.asset?.name]);

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3}>
          <Grid container spacing={3} xs={12} md={6}>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Ngày đổ" value={item.paidDate} dateFormat='dd/MM/yyyy' />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Trạm xăng" value={item.partner?.label} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Người đổ" value={item.contact?.name} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Số điện thoại" value={item.contact?.phone} enumType="phone" />
            </Grid>
            <Grid xs={12} md={12}>
              <ReadOnlyTextField label="Số xe" value={item.car?.name} />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Số lượng" value={item.quantity} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Đơn giá" value={item.price} enumType="decimal" />
            </Grid>

            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Số thẻ" value={item.cardNumber} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Thanh toán" value={item.totalPrice} color={item.paymentColor} />
            </Grid>

            <Grid xs={12}>
              <QuillEditor
                value={item.note}
                isReadOnly={true}
              />
            </Grid>
            
          </Grid>
          <Grid xs={12} md={6}>
            <ZoomImage
              thumbSrc={imageSrc}
              zoomSrc={imageSrc}
              alt={item.id}
              height="480"
              frame="auto"
            />
          </Grid>
          {item.payment?.status === 0 && (
            <Grid xs={12} md={6} display="flex"
                  sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Button variant="contained" onClick={() => {
                  const updatedPayment = {
                    ...item.payment,
                    status: 2,
                  };
                  apiPayBill(updatedPayment);
                }}>
                Thanh toán
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

DetailView.propTypes = {
  item: PropTypes.object.isRequired,
};